import React from 'react';

import Layout from '../components/Layout';
import BlogMasthead from '../components/BlogMasthead';
import ConnectSection from '../components/ConnectSection';
import Footer from '../components/Footer';
import Partners from '../components/Partners';
import Navbar from '../components/Navbar';
import '../styles/BlogListTemplate.scss';

const BlogTemplate = (props) => {
	return (
		<Layout>
			<Navbar />
			<BlogMasthead />
			<section className="blog section">
				<div className="container">
					<div className="columns">
						<div className="column is-8">
							<h3 className="date">{props.pageContext.date}</h3>
							<h1 className="reg-heading">{props.pageContext.title}</h1>
							<h3 className="author">{props.pageContext.author}</h3>
							<div
								dangerouslySetInnerHTML={{ __html: props.pageContext.html }}
							/>
						</div>
					</div>
				</div>
			</section>
			<ConnectSection />
			<Partners />
			<Footer />
		</Layout>
	);
};

export default BlogTemplate;
